import { fetchPropertyAdminAction } from 'redux/actions/propertiesActions';
import { generateRequestWithDataReducer } from 'redux/utils/requestWithData';

export default generateRequestWithDataReducer(fetchPropertyAdminAction);
